/* eslint-disable arrow-body-style */
/* eslint-disable import/prefer-default-export */
export const formatStateToCheckout = (values) => {
  return {
    invoiceAddress: values.invoiceAddress?.forename ? values.invoiceAddress : undefined,
    lineItems: Object.entries(values)
      .filter(([key]) => key.startsWith('product_'))
      .map(([key, value]) => ({
        productId: parseInt(key.replace('product_', '')),
        quantity: value,
        attendees: (values[`productAttendee_${key.replace('product_', '')}`] || [])
          .map((orgAttendee) => {
            const attendee = { ...orgAttendee };
            delete attendee.custom_attributes;
            return attendee;
          }),
      })),
  };
};

export const formatCheckoutDataToState = (data) => {
  if (!data?.getDetails) return { invoiceAddress: { country: 'DE' } };
  return {
    invoiceAddress: data?.getCheckout?.invoiceAddress || { country: 'DE' },
    ...(data?.getDetails?.products?.reduce((acc, product) => {
      const lineItem = data?.getCheckout?.lineItems?.find(({ productId }) => productId === product.id);
      acc[`product_${product.id}`] = lineItem?.quantity || 0;
      acc[`productAttendee_${product.id}`] = lineItem?.attendees || [];
      return acc;
    }, {})),
  };
};

export const formatNumber = (value) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);

const normalizePriceDisplayMode = (mode) => {
  if (['configured', 'gross', 'net', 'both'].includes(mode)) return mode;
  return 'configured';
};

export const resolvePriceDisplayMode = (priceDisplayMode, priceModel) => {
  const normalizedMode = normalizePriceDisplayMode(priceDisplayMode);
  if (normalizedMode !== 'configured') return normalizedMode;
  return priceModel === 'net' ? 'net' : 'gross';
};

const hasSalePrice = (salePrice, basePrice) => (
  salePrice !== null
  && salePrice !== undefined
  && basePrice !== null
  && basePrice !== undefined
  && Number(salePrice) !== Number(basePrice)
);

export const getTicketCardPriceView = (product, effectiveMode) => {
  const gross = {
    price: product?.price,
    salePrice: product?.salesPrice,
    showSale: hasSalePrice(product?.salesPrice, product?.price),
  };
  const net = {
    price: product?.priceNet,
    salePrice: product?.salesPriceNet,
    showSale: hasSalePrice(product?.salesPriceNet, product?.priceNet),
  };

  return {
    mode: effectiveMode,
    gross,
    net,
  };
};
